import { SavePolygonsModal } from './savePolygonsModal';
export default SavePolygonsModal;
